export function validateUserDetail(e, type, value, isValidate = true) {
    const validate = [];
    const requiredFields = [
        'userPhone',
        'userName',
        'expertName',
        'description',
        'title',
        'avatarUrl',
        'file',
        'expertSkillLevel',
        'availableForSession',
        'language',
        'content_1_description',
        'content_1_video',
        'content_1_thumbnail',
        'content_2_description',
        'content_2_video',
        'content_2_thumbnail',
        'content_3_description',
        'content_3_video',
        'content_3_thumbnail',
    ]

    const fixedLengthFields = [
        'userPhone'
    ]
    if (requiredFields.includes(type)) { if (required(e)?.valid && isValidate) { validate.push(required(e)); } }

    if (fixedLengthFields.includes(type)) {
        if (fixedLength(e, 10)?.valid && isValidate) { validate.push(fixedLength(e, 10)); }
    }
    return validate;
}

export function required(e) {
    if ((Array.isArray(e) && e.length === 0) || e === '' || e === null || e === undefined) {
        return response('This field is required', false)
    } else {
        return response('', true)
    }
}

export function fixedLength(e, length) {
    if (e?.length === length) {
        return response('', true)
    } else {
        return response(`This field must contains ${length}`, false)
    }

}
export function maxLength(e, length) {
    if (e?.length >= length) {
        return response('', true)
    } else {
        return response(`This field should be less than ${length}`, false)
    }

}

export function minLength(e, length) {
    if (e?.length <= length) {
        return response('', true);
    } else {
        return response(`This field should be greater than ${length}`, false)
    }

}

export function response(msg, valid) {
    return {
        msg,
        valid: !valid
    }
}